import {Injectable} from '@angular/core';

@Injectable()
export class InformationModalService {

    informationModal:boolean;
    informationModalData:any;
    vcc:any;
    displayVccModal:boolean;

    constructor(){
        this.vcc = {};
        this.displayVccModal = false;
        this.informationModal = false;
        this.informationModalData = {title: "", texts: [], subtitles: []};
    }

    setVcc(vcc, dropoffDate) {
        if (vcc) {
            this.vcc = vcc;
            this.vcc.dropoffDate = dropoffDate;
        }
    }

    getVcc() {
        return this.vcc;
    }

    showVcc() {
        this.displayVccModal = true;
    }

    hideVcc() {
        this.displayVccModal = false;
    }

    showVccModal = function () {
        return this.displayVccModal;
    }

    showInformationModal(){
        this.informationModal = true;
    }

    hideInformationModal(){
        this.informationModal = false;
    }

    getInformationModal(){
        return this.informationModal;
    }

    setInformationModalData(obj){
        this.informationModalData = obj;
    }

    getInformationModalData(){
        return this.informationModalData;
    }

    setTitle(title){
        this.informationModalData.title = title;
    }

    setTexts(texts){
        this.informationModalData.texts = texts;
    }

    setSubtitles(subtitles){
        this.informationModalData.subtitles = subtitles;
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/root/information-modal/information-modal.service.ts